import { render } from "./APPNavbar.vue?vue&type=template&id=16874c77&scoped=true"
import script from "./APPNavbar.vue?vue&type=script&lang=js"
export * from "./APPNavbar.vue?vue&type=script&lang=js"

import "./APPNavbar.vue?vue&type=style&index=0&id=16874c77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16874c77"]])

export default __exports__